var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlechaPrestacionDer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33366 6.66657H8.78033L5.52699 9.9199C5.26699 10.1799 5.26699 10.6066 5.52699 10.8666C5.78699 11.1266 6.20699 11.1266 6.46699 10.8666L10.8603 6.47323C11.1203 6.21323 11.1203 5.79323 10.8603 5.53323L6.47366 1.13323C6.21366 0.873232 5.79366 0.873232 5.53366 1.13323C5.27366 1.39323 5.27366 1.81323 5.53366 2.07323L8.78033 5.33323H1.33366C0.966992 5.33323 0.666992 5.63323 0.666992 5.9999C0.666992 6.36657 0.966992 6.66657 1.33366 6.66657Z",
    fill: "#323232"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechaPrestacionDer);
export default __webpack_public_path__ + "static/media/flechaPrestacionDer.c9aab2f202c57b43761ffe14eeba5756.svg";
export { ForwardRef as ReactComponent };